var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-text-field", {
    staticClass: "elevation-0",
    attrs: {
      rounded: "",
      flat: "",
      "data-testid": "filter-search-input",
      "prepend-inner-icon": "search",
      label: _vm.$t("general.search"),
      solo: "",
      dense: "",
      "hide-details": "",
    },
    on: {
      input: function ($event) {
        return _vm.onFilterChange($event)
      },
      blur: function ($event) {
        return _vm.onBlur()
      },
    },
    model: {
      value: _vm.filterText,
      callback: function ($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }